import locale from './locale'
import dialogs from './dialogs'
import validation from './validation'
import Base64 from 'crypto-js/enc-base64'
import CryptoJS from 'crypto-js'
import useIEHelper from '@/commons/ie-helper'
import { debounce } from 'debounce'
import { buildWLParam } from '@/commons/whitelabel'
const { URLSearchParamsWrapper } = useIEHelper()
export default {
  mixins: [locale, dialogs, validation],
  data () {
    return {
      defaultEmail: '',
      isTouchable: this.$machine.isTouchable,
      submit: false,
      errorMessage: null,
      HTTPCode: null,
      email: '',
      urlParams: null,
      accessMethods: [],
      capsLock: null
    }
  },
  beforeMount () {
    window.addEventListener('keyup', function (event) {
      this.capsLock =
        event && typeof event.getModifierState === 'function'
          ? event.getModifierState('CapsLock') : false
    })
    let self = this
    this.$root.$on('closeDialog', () => {
      self.showDialog = false
    })
    this.urlParams = URLSearchParamsWrapper(window.location.search)
    this.$i18n.locale = this.hl()
    this.errorMessage = this.urlParams.get('error_message') || ''
    if (this.errorMessage === 'invalid credentials') {
      if (this.$allowSelfRegistration) {
        this.errorMessage = 'That Idonia account doesn\'t exist'
        this.errorLink = {
          label: 'get a new one',
          link: 'register.html?email=' +
            encodeURIComponent(this.email) +
            '&access_methods=' + this.urlStringMethods() +
            buildWLParam(this.$wlDomain)
        }
      } else {
        this.errorMessage = 'AccountNotFound'
        this.errorLink = null
      }
    }
    this.HTTPCode = this.urlParams.get('status_code') || ''
  },
  mounted () {
    this.$root.$on('do', (func) => {
      this.$root.errorMessage = ''
      this.errorMessage = ''
      this.$log.log('doing', func)
      if (func) {
        let splited = func.split(',')
        let method = splited[0]
        let params = splited.slice(1, splited.length)
        switch (method) {
          case 'getChallenge':
            this.getChallenge()
            break
          case 'sendEmail':
            this.sendEmail()
            break
          case 'goTo':
            this.goTo(...params)
            break
          case 'submitForm':
            this.submitForm(...params)
        }
      }
    })
  },
  destroyed () {
    this.$root.$off('do')
    this.$root.$off('closeDialog')
  },
  methods: {
    goTo (view, query = '') {
      this.errorMessage = ''
      window.location.href = '/' + view + '?hl=' + this.hl() + query + buildWLParam(this.$wlDomain)
    },
    open (url) {
      window.open(url, '_blank')
    },
    success () {
      this.errorMessage = ''
    },
    submitForm: debounce(function (formId) {
      this.submit = true
      this.$log.log(this.$refs.form)
      this.$log.log(this.$refs[formId].$refs.form)
      this.$log.log(this.$refs[formId] && this.$refs[formId].$refs.form, this.$refs[formId].$refs.form.validate())
      if ((this.$refs.form && this.$refs.form.validate()) ||
          (this.$refs[formId] && this.$refs[formId].$refs.form && this.$refs[formId].$refs.form.validate())) {
        document.getElementById(formId).submit()
      } else {
        this.$log.warn('invalid Form')
        this.$nextTick(() => { this.submit = false })
      }
    }, 1000, true),
    error (error) {
      this.errorMessage = error.body.error || ''
      this.HTTPCode = error.status || null
    },
    lMethods () {
      if (this.$methods && this.$methods.length > 0) {
        return this.$methods
      }
      this.goTo('error', '&error_message=accessMethodError' + buildWLParam(this.$wlDomain))
    },
    canAccess (type) {
      if (this.accessMethods) {
        return this.accessMethods.find((item) => item ? item.type === type : false)
      }
    },
    urlStringMethods () {
      if (!this.$methods) {
        return ''
      }
      let methods = Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(this.$methods)))
      methods = methods.replace(/\+/g, '.').replace(/\//g, '_').replace(/=/g, '-')
      return methods
    },
    getMethodUrl (method) {
      let params = '?client_id=' + method.client_id +
        '&redirect_uri=' + method.redirect_uri +
        '&response_type=' + method.response_type +
        '&scope=' + method.scopes.join(' ') +
        buildWLParam(this.$wlDomain)
      this.$log.log(params)
      if (method.additional_params) {
        for (let i = 0; i < method.additional_params.length; i++) {
          params = params + '&' + method.additional_params[i].key +
            '=' + method.additional_params[i].value
          this.$log.log(params)
        }
      }
      this.$log.log('DEBUG url: ', method.url + encodeURI(params))
      return method.url + encodeURI(params)
    },
    completeLoginMethods () {
      const _self = this
      if (!this.accessMethods || this.accessMethods.length === 0) {
        this.goTo('error', '&error_message=accessMethodError' + buildWLParam(this.$wlDomain))
      }
      this.accessMethods.filter(method => method && method.type !== 'password').forEach((method, index, methods) => {
        this.$log.log('default')
        methods[index]['id'] = method.oauth2_access_method.theme.name
        methods[index]['idpId'] = method.oauth2_access_method.id
        const stateParam = (method.oauth2_access_method.additional_params || []).find(p => p.key === 'state')
        methods[index]['state'] = stateParam ? stateParam.value : ''
        methods[index]['color'] = method.oauth2_access_method.theme.color
        methods[index]['src'] = method.oauth2_access_method.theme.icon
        methods[index]['openMode'] = method.oauth2_access_method.theme.method || 'sameTab'
        methods[index]['flavor'] = methods[index].oauth2_access_method.flavor
        methods[index]['url'] = this.getMethodUrl(methods[index].oauth2_access_method)
        this.$log.log('methods: ', methods[index])
        this.$log.log('am: ', this.accessMethods)
        switch (method.oauth2_access_method.flavor) {
          case 'google':
            document.addEventListener('googleAuth2', (e) => {
              this.$log.log('really', e)
              this.$log.log('raw: ', this.getMethodUrl(methods[index].oauth2_access_method))
              this.$log.log('split: ', this.getMethodUrl(methods[index].oauth2_access_method).split('?')[1])
              let params = URLSearchParamsWrapper(this.getMethodUrl(methods[index].oauth2_access_method).split('?')[1])
              let auth2 = e.detail.init(params.browserIsDeprecated
                ? (() => {
                  delete params.browserIsDeprecated
                  return params
                })()
                : Object.fromEntries(params)
              )
              auth2.attachClickHandler(document.getElementById('my-signin2'), {},
                function (googleUser) {
                  _self.$log.log('Logged in form access as: ' + googleUser.getBasicProfile().getName())
                  _self.$log.log(googleUser)
                }, function (error) {
                  _self.$log.log(JSON.stringify(error, undefined, 2))
                })
            }
            )

            let script2 = document.createElement('script')
            script2.setAttribute('src', 'https://apis.google.com/js/platform.js?onload=init')
            script2.setAttribute('async', '')
            script2.setAttribute('defer', '')
            document.head.appendChild(script2)
            let script3 = document.createElement('script')
            script3.setAttribute('type', 'text/javascript')
            script3.text = `
              function init() {
              console.log("DEBUG INIT ")
                  gapi.load('auth2', function() {
                  console.log('gapi?', gapi.auth2);
                  var event = new CustomEvent('googleAuth2',{detail: gapi.auth2});
                  document.dispatchEvent(event);
  });
}`
            document.head.appendChild(script3)
            break
        }
      })
    }
  }
}
